import styled from 'styled-components';

export const CRMLeftContainer = styled.div`
  padding-left: 2rem;
  padding-top: 2rem;
  padding-right: 2rem;
`;
